// Store Vuex
import { Commit, Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';

import { Garde } from '@/services/api/types';
import { getGardesFromApi, getGardesAValiderFromApi } from '@/services/api/api';

export interface GardesState {
  gardes: Garde[] | null;
}

export const state: GardesState = {
  gardes: null
};

// Les actions permettent l'exécution de code asynchrone
export const actions: ActionTree<GardesState, RootState> = {
  // Action pour stocker la liste des gardes de l'utilisateur dans le store
  async fetchGardes({ commit }: { commit: Commit }) {
    const response = await getGardesFromApi();
    if (response && 'data' in response) {
      const gardesData: Garde[] | null = response.data;

      commit('SET_GARDES', gardesData);
    }
  },
  async fetchGardesAValider({ commit }: { commit: Commit }) {
    const response = await getGardesAValiderFromApi();
    if (response && 'data' in response) {
      const gardesData: Garde[] | null = response.data;

      commit('SET_GARDES', gardesData);
    }
  },
  async clearGarde({ commit }: { commit: Commit }) {
    commit('SET_GARDES', null);
  }
};

export const mutations: MutationTree<GardesState> = {
  SET_GARDES(state: GardesState, gardes: Garde[] | null) {
    state.gardes = gardes;
  }
};

export const getters: GetterTree<GardesState, RootState> = {
  getGardes: (state) => state.gardes
};

// Définition du module
export const garde: Module<GardesState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
